import { ApiService } from './../../services/api-service/api.service';
import { Component, OnInit, Output, EventEmitter, Input, NgZone, ViewChild, ElementRef } from '@angular/core';
declare const google: any;
@Component({
  selector: 'google-autocomplete',
  templateUrl: './google-autocomplete.component.html',
  styleUrls: ['./google-autocomplete.component.scss'],
  host: {
    '(document:click)': 'onClick($event)',
  }
})

export class GoogleAutocompleteComponent implements OnInit {
  listAddress: any[] = [];
  keySearch: string;
  geocoder: any;
  service: any;
  showListAddress: boolean = false;
  @Input() address;
  @Output() pick = new EventEmitter();
  @ViewChild('zoneSelect') zoneSelect: ElementRef;
  indexDraff: number = -1;
  constructor(private _apiService: ApiService, private zone: NgZone) { }

  ngOnInit() {
    this.service = new google.maps.places.AutocompleteService();
  }
  ngOnChanges() {
    this.keySearch = this.address;
  }
  onChange() {
    if (!this.keySearch) {
      this.pick.emit('');
    };
    let req = {
      input: this.keySearch ? this.keySearch : ' '
    };
    this.service.getQueryPredictions(req, (res, status) => {
      this.zone.run(() => {
        if (res) {
          this.listAddress = res;
          this.showListAddress = true;
        } else {
          this.listAddress = [];
          this.showListAddress = false;
        }
      })
    })
  }
  pickAddress(address) {
    this.keySearch = address.description;
    this.showListAddress = false;
    this.pick.emit(address);
  }
  onClick(event) {
    if (!this.zoneSelect.nativeElement.contains(event.target))
      this.showListAddress = false;
  }
  onKeydown(event) {
    switch (event.key) {
      case 'ArrowUp':
        this.indexDraff <= 0 ? this.indexDraff = this.listAddress.length - 1 : this.indexDraff--;
        break;
      case 'ArrowDown':
        this.indexDraff == this.listAddress.length - 1 ? this.indexDraff = 0 : this.indexDraff++;
        break;
      case 'Enter': {
        if (this.indexDraff >= 0) this.pickAddress(this.listAddress[this.indexDraff])
      }
      default:
        break;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/components/google-autocomplete/google-autocomplete.component.ts